const frJSON = {
  'Accent Sidebar': "Barre latérale d'accentuation"
};

export default frJSON;
